import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './SVGIcon.module.css';

const SVGIcon = forwardRef(function SVGIcon(
  { viewBox = '0 0 24 24', className, size, color, ratio, children, ...rest },
  forwardedRef
) {
  return (
    <svg
      ref={forwardedRef}
      viewBox={viewBox}
      className={classNames(styles.root, styles[size], styles[color], styles[ratio], className)}
      aria-hidden={true}
      {...rest}
    >
      {children}
    </svg>
  );
});

export default SVGIcon;
